<template>
  <vxe-modal v-model="flag" title="电子回单" width="1200" height="800" resize>
    <div v-for="(item,index) in srcList" :key="index">
      <iframe :src="item" frameborder="0" width="100%" height="800px" />
    </div>
  </vxe-modal>
</template>
<script>
export default {
  data() {
    return {
      flag: false,

      srcList: []
    };
  },
  methods: {
    show(item) {
      this.flag = true;
      this.srcList = item;
    }
  }
};
</script>